/* @flow */
import * as React from 'react';

function Totals(): React.Node {
  // TODO: Implement Totals page
  return <div>Totals</div>;
}

export default Totals;
